import type { Asset } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const updateFields: FormItem<Asset>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Details',
    items: [allFields.tenantId, allFields.assetTag],
  },
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.image],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [
          allFields.serialNumber,
          allFields.state,
          allFields.locationId,
          allFields.installDate,
        ],
      },
      {
        colCount: 1,
        colSpan: 4,
        items: [allFields.description],
      },
    ],
  },
  {
    colCount: 3,
    cssClass: 'tmm-section',
    caption: 'Classification',
    items: [allFields.assetTypeId, allFields.makeId, allFields.modelId],
  },
  {
    colCount: 2,
    cssClass: 'tmm-section',
    caption: 'Costs',
    items: [allFields.acquisitionCostValue, allFields.maintenanceCostValue],
  },
  {
    colCount: 2,
    cssClass: 'tmm-section',
    caption: 'Risk Assessment',

    items: [allFields.condition, allFields.usefulLife],
  },
  getHistorySection(),
];

export const createFields: FormItem<Asset>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Details',
    items: [allFields.tenantId, allFields.assetTag],
  },
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.image],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [
          allFields.serialNumber,
          allFields.state,
          allFields.locationId,
          allFields.installDate,
        ],
      },
      {
        colCount: 1,
        colSpan: 4,
        items: [allFields.description],
      },
    ],
  },
  {
    colCount: 3,
    cssClass: 'tmm-section',
    caption: 'Classification',
    items: [allFields.assetTypeId, allFields.makeId, allFields.modelId],
  },
  {
    colCount: 2,
    cssClass: 'tmm-section',
    caption: 'Costs',
    items: [allFields.acquisitionCostValue, allFields.maintenanceCostValue],
  },
  {
    colCount: 2,
    cssClass: 'tmm-section',
    caption: 'Risk Assessment',

    items: [allFields.condition, allFields.usefulLife],
  },
];

export const createFields22: FormItem<Asset>[] = [
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    items: [
      allFields.image,
      {
        colCount: 1,
        colSpan: 3,
        items: [allFields.assetTag, allFields.serialNumber, allFields.state],
      },
    ],
  },
  { colCount: 1, items: [allFields.description] },
  {
    colCount: 2,
    items: [allFields.assetTypeId, allFields.usefulLife],
  },
  {
    colCount: 2,
    items: [allFields.makeId, allFields.modelId],
  },
  {
    colCount: 2,
    items: [allFields.locationId, allFields.installDate],
  },
  {
    colCount: 2,
    items: [allFields.acquisitionCostValue, allFields.maintenanceCostValue],
  },
];
